import { render, staticRenderFns } from "./dialog-video.vue?vue&type=template&id=276cc7b8&scoped=true"
import script from "./dialog-video.vue?vue&type=script&lang=js"
export * from "./dialog-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276cc7b8",
  null
  
)

export default component.exports